const localstorage = {
    REDIRECT_URL: 'redirectUrl',
    SITE_LANG: 'siteLang'
}
export default localstorage;